import {
	type PrimaryProductKey,
	PrimaryProductKeys,
	ProductKeys,
	PRODUCTS_ORDER,
	PRODUCTS_ORDER_WITH_3P_BY_POPULARITY,
} from '../constants/products';

import { serveRightRailImprovementsWithoutExposure } from './experiments';

export const isAllProductSearch = (selectedProducts: ProductKeys[]) => selectedProducts.length === 0;

export const getProductOrder: (
	a: ProductKeys,
	b: ProductKeys,
	productsOrder: ProductKeys[],
) => number = (a: ProductKeys, b: ProductKeys, productsOrder: ProductKeys[]) => {
	const indexA = productsOrder.indexOf(a);
	const indexB = productsOrder.indexOf(b);

	if (indexA === -1 || indexB === -1) {
		return 0;
	} else {
		return indexA - indexB;
	}
};

export const getProductsOrderByPrimaryProduct: (
	primaryProduct: PrimaryProductKey | undefined,
) => ProductKeys[] = (primaryProduct: PrimaryProductKey | undefined): ProductKeys[] => {
	if (primaryProduct === PrimaryProductKeys.Assets) {
		return [ProductKeys.Assets, ...PRODUCTS_ORDER];
	}

	const productsOrder = serveRightRailImprovementsWithoutExposure()
		? PRODUCTS_ORDER_WITH_3P_BY_POPULARITY
		: PRODUCTS_ORDER;

	if (primaryProduct === PrimaryProductKeys.Jira) {
		const jiraProducts: ProductKeys[] = [
			ProductKeys.Jira,
			ProductKeys.Confluence,
			ProductKeys.JiraProductDiscovery,
			ProductKeys.JiraServiceManagement,
		];
		// Bring all Jira products to the top
		return [...jiraProducts, ...productsOrder.filter((key) => !jiraProducts.includes(key))];
	}

	return productsOrder;
};

export const isJiraProduct: (product?: ProductKeys) => boolean = (
	product?: ProductKeys,
): boolean => {
	const jiraProducts = [
		ProductKeys.Jira,
		ProductKeys.JiraProductDiscovery,
		ProductKeys.JiraServiceManagement,
	] satisfies ProductKeys[];

	return Boolean(jiraProducts.find((jiraProduct) => jiraProduct === product));
};
